// HEADER JS START

document.addEventListener('DOMContentLoaded', function () {
  const menuItems = document.querySelectorAll('header-menu > details');

  menuItems.forEach((item) => {
    const summary = item.querySelector('summary');

    // Open on mouseenter
    item.addEventListener('mouseenter', () => {
      item.setAttribute('open', '');
      summary.setAttribute('aria-expanded', 'true');
    });

    // Close on mouseleave
    item.addEventListener('mouseleave', () => {
      item.removeAttribute('open');
      summary.setAttribute('aria-expanded', 'false');
    });
  });
});



document.addEventListener('DOMContentLoaded', function () {
  const titles = document.querySelectorAll(
    '.article-template__content .accordion-title'
  );

  titles.forEach(title => {
    title.addEventListener('click', function () {

      // Close other accordions
      titles.forEach(otherTitle => {
        if (otherTitle !== this) {
          otherTitle.classList.remove('active');
          const otherContent = otherTitle.nextElementSibling;
          if (otherContent) {
            otherContent.style.maxHeight = null;
          }
        }
      });

      // Toggle current accordion
      this.classList.toggle('active');
      const content = this.nextElementSibling;

      if (content) {
        if (content.style.maxHeight) {
          content.style.maxHeight = null;
        } else {
          content.style.maxHeight = content.scrollHeight + 'px';
        }
      }
    });
  });
});




// HEADER JS END

// document.addEventListener("DOMContentLoaded", function () {
//   const iframe = document.querySelector("#iframe-container > kickflip-customizer-iframe").shadowRoot.querySelector("iframe");

//   iframe.onload = function () {
//     const input = iframe.contentWindow.document.querySelector(".bulk-order-quantity-input");

//     if (input) {
//       input.value = 50; // change value
//     } else {
//       console.warn("Input not found in iframe.");
//     }
//   };
// });

